<template>
    <div class="tile-content" v-fs-block>
        <v-repeater :list="upcomingInvoices">
            <template #headers>
                <th>To be Issued</th>
                <th>Products</th>
                <th>Amount</th>
            </template>
            <template #iteratee="{item}">
                <td v-fs-block><router-link :to="{name: 'order-upcoming-invoice', params: {id: order.id}}">{{item.issuedTime | dateUTC('shortDate')}}</router-link></td>
                <td v-fs-block>{{item.productNames | join | coverEmpty}}</td>
                <td v-fs-block>{{item.amount | monetizeExplicit(item.currency)}}</td>
            </template>
            <template #no-content>
                <p class="text-muted">This order has no upcoming invoices</p>
            </template>
        </v-repeater>
    </div>
</template>

<script>
    import {vIcon, vIconButton} from '@/components/form/index';
    import vRepeater from '@/components/repeater/repeater';
    import {getBadgeType} from '@/data/badges-color-map';
    import InvoiceModel from '@/common/models/invoice-model';

    export default {
        name: 'invoices-upcoming',
        components: {
            vRepeater,
            vIcon,
            vIconButton,
        },
        props: {
            order: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                upcomingInvoices: [],
            };
        },
        watch: {
            order: {
                immediate: true,
                handler() {
                    this.fetchData();
                },
            },
        },
        methods: {
            getBadgeType,
            async fetchData() {
                if (this.order && this.order.id) {
                    const upcomingInvoicesParams = {
                        id: this.order.id,
                        expand: 'organization,items.*.product,items.*.plan',
                    };
                    const {items: invoicesItems} = await this.$api(({subscriptions}) => subscriptions.getAllUpcomingInvoices(upcomingInvoicesParams));
                    this.upcomingInvoices = invoicesItems.map(item => new InvoiceModel(item.fields));
                }
            },
        },
    };
</script>

<style scoped>

</style>
